export default __webpack_public_path__ + "static/media/cert-general-staff-a-consumer.0390698e.jpg";